export const EDDY_TRUSTED_ORIGINS = [
  'http://localhost:5173',
  'https://eddy-dev1.headliner.app',
  'https://eddy.headliner.app',
];
